import React from "react";
import { company } from "../mock";

export const Footer = () => {
  return (
    <footer className="pad-large" style={{borderTop: "1px solid var(--border-subtle)", background: "var(--bg-primary)"}}>
      <div className="dark-content-container flex flex-col md:flex-row items-start justify-between gap-6">
        <div>
          <div className="heading-2">{company.name}</div>
          <div className="body-small">{company.tagline}</div>
          <div className="body-small mt-2">{company.address}</div>
        </div>
        <div className="flex gap-6">
          <a className="dark-nav-link" href="/mentions-legales">Mentions légales</a>
          <a className="dark-nav-link" href="/cgu">CGU</a>
        </div>
      </div>
    </footer>
  );
};
